import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { SVGUniqueID } from '@ali/we-icons-utils';
export var Colorcheck16 = /*#__PURE__*/memo(props => /*#__PURE__*/React.createElement(SVGUniqueID, null, /*#__PURE__*/React.createElement("svg", _extends({
  width: typeof props.size === 'number' ? props.size : 16,
  height: typeof props.size === 'number' ? props.size : 16,
  fill: "none",
  viewBox: "0 0 16 16",
  className: "_colorcheck16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.94,
  d: "M13.8 5.2a1 1 0 0 1-.293.707l-6 6a1 1 0 0 1-1.414 0l-3.2-3.2a1 1 0 0 1 1.414-1.414L6.8 9.786l5.293-5.293A1 1 0 0 1 13.8 5.2Z"
}))));